<app-login-component
  logoUrl='AiwynLogo.png'
  guestEnabled=true
  (onCreateAccountRequested)="createAccount()"
></app-login-component>
